const PROFILE_CREATOR_PREFERENCES_DOMAIN = 'profileCreatorPreferences'

const PROFILE_CREATOR_PREFERENCES_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}

const PROFILE_CREATOR_PREFERENCES_ACTION = {
  LOAD_PROFILE_CREATOR_PREFERENCES: 'LOAD_PROFILE_CREATOR_PREFERENCES',
  SAVE_PROFILE_CREATOR_PREFERENCES: 'SAVE_PROFILE_CREATOR_PREFERENCES',
  UPDATE_CURRENT: 'PROFILE_CREATOR_PREFERENCES_UPDATE_CURRENT',
  RESET_CURRENT: 'PROFILE_CREATOR_PREFERENCES_RESET_CURRENT',
  UPDATE_NOTIFICATION_DISABLED: 'UPDATE_NOTIFICATION_DISABLED'
}

const PROFILE_CREATOR_PREFERENCES_PATH = {
  ALL: `${PROFILE_CREATOR_PREFERENCES_DOMAIN}.${PROFILE_CREATOR_PREFERENCES_KEY.ALL}`,
  CURRENT: `${PROFILE_CREATOR_PREFERENCES_DOMAIN}.${PROFILE_CREATOR_PREFERENCES_KEY.CURRENT}`,
  DATA: `${PROFILE_CREATOR_PREFERENCES_DOMAIN}.${PROFILE_CREATOR_PREFERENCES_KEY.DATA}`
}

const PROFILE_CREATOR_PREFERENCES_STATE = {
  [PROFILE_CREATOR_PREFERENCES_KEY.ALL]: {
    data: [],
    status: null
  },
  [PROFILE_CREATOR_PREFERENCES_KEY.CURRENT]: null,
  [PROFILE_CREATOR_PREFERENCES_KEY.DATA]: {}
}

const PROFILE_CREATOR_PREFERENCES_ENDPOINT = {
  LOAD_PROFILE_CREATOR_PREFERENCES: '/profile-creator-preferences',
  SAVE_PROFILE_CREATOR_PREFERENCES: '/profile-creator-preferences/:id'
}

export {
  PROFILE_CREATOR_PREFERENCES_DOMAIN,
  PROFILE_CREATOR_PREFERENCES_KEY,
  PROFILE_CREATOR_PREFERENCES_ACTION,
  PROFILE_CREATOR_PREFERENCES_PATH,
  PROFILE_CREATOR_PREFERENCES_STATE,
  PROFILE_CREATOR_PREFERENCES_ENDPOINT
}
